<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" :width="computedWidth">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0 title-mobile" primary-title>
          {{ computedTitle }}
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="tipoProjeto.Descricao"
                  label="Descrição"
                  prepend-icon="description"
                  @keyup.enter="adiciona"
                  id="tipoprojeto-add-item"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete 
                  v-model="tipoProjetoTipoAtividade.TipoAtividade"
                  :items="tiposAtividadeAtivo"
                  item-text="Descricao"
                  return-object
                  id="tipoprojtipoat-add-item"
                  menu-props="auto"
                  label="Adicionar Tipo Atividade"
                  no-data-text="Registro não encontrado."
                  prepend-icon="label"
                  auto-select-first
                  @change="changeTipoAtividade"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-card>
                  <v-toolbar dense dark color="primary">
                    <v-toolbar-title>Tipos Atividade</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="pa-0">
                    <!-- Lista Tipos Atividade -->
                    <v-flex xs12>
                      <v-list v-if="computedTiposAtividade.length">
                        <template v-for="(tipoAtividade, index) in computedTiposAtividade">
                          <v-list-tile :key="tipoAtividade.IdTipoAtividade">
                            <v-list-tile-content>
                              <v-list-tile-title>{{ tipoAtividade.TipoAtividade }}</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                              <div class="d-flex justify-end">
                                <v-tooltip bottom>
                                  <v-btn
                                    icon
                                    flat
                                    small
                                    class="mx-0"
                                    slot="activator"
                                    @click="excluiTipoAtividade(tipoAtividade)"
                                  >
                                    <v-icon small>delete</v-icon>
                                  </v-btn>
                                  <span>Excluir</span>
                                </v-tooltip>
                              </div>
                            </v-list-tile-action>
                          </v-list-tile>
                          <v-divider
                            v-if="index !== computedTiposAtividade.length - 1"
                            :key="index + tipoAtividade.TipoAtividade"
                            class="mx-2"
                          ></v-divider>
                        </template>
                      </v-list>
                      <div v-else class="d-flex my-3">
                        <span class="text-xs-center font-weight-bold">Nenhum tipo atividade adicionado à esse tipo projeto.</span>
                      </div>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import TipoProjeto from '@/domain/tipoProjeto/TipoProjeto';
import TipoProjetoTipoAtividade from '@/domain/tipoProjeto/TipoProjetoTipoAtividade';

export default {
  name: 'ModalCadastroTipoProjeto',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tipoProjeto: {
      type: Object,
      default: () => new TipoProjeto()
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      tipoProjetoTipoAtividade: new TipoProjetoTipoAtividade(),
      tiposAtividadeAdicionar: []
    }
  },
  watch: {
    value(newValue) {
      if (newValue && !this.tiposAtividadeAtivo.length) this.fetchTiposAtividade();
      this.$nextTick(() => document.getElementById('tipoprojeto-add-item').focus());
    }
  },
  computed: {
    ...mapGetters(['tipoProjetoTiposAtividade', 'tiposAtividadeAtivo']),
    computedTitle() {
      return this.tipoProjeto.IdTipoProjeto ? 'Editar Tipo Projeto' : 'Novo Tipo Projeto';
    },
    computedWidth() {
      return this.$vuetify.breakpoint.smAndDown ? '100%' : '60%';
    },
    computedTiposAtividade() {
      if (this.tipoProjetoTiposAtividade.length) return this.tipoProjetoTiposAtividade;
      if (this.tiposAtividadeAdicionar.length) return this.tiposAtividadeAdicionar;
      return [];
    },
  },
  methods: {
    ...mapActions([
      'fetchTiposAtividade',
      'addTipoProjeto',
      'addTipoProjetoTipoAtividade',
      'updateTipoProjeto',
      'deleteTipoProjetoTipoAtividade'
    ]),
    ...mapMutations(['showNotification', 'closeNotification']),
    async changeTipoAtividade(obj) {
      this.tipoProjetoTipoAtividade.IdTipoAtividade = obj.IdTipoAtividade;
      this.tipoProjetoTipoAtividade.TipoAtividade = obj.Descricao;
      const newTipoProjetoTipoAtividade = Object.assign({}, this.tipoProjetoTipoAtividade);

      if (this.tipoProjeto.IdTipoProjeto) {
        newTipoProjetoTipoAtividade.IdTipoProjeto = this.tipoProjeto.IdTipoProjeto;
        try {
          this.loading = true;
          const tipoAtividadeAdicionado = await this.addTipoProjetoTipoAtividade(newTipoProjetoTipoAtividade);
          if (tipoAtividadeAdicionado && tipoAtividadeAdicionado.data.IdTipoAtividade) {
            this.showNotification({ text: `Tipo Atividade ${obj.Descricao} adicionado ao tipo projeto.`, status: 'success' });
            this.tipoProjetoTipoAtividade = Object.assign({}, new TipoProjetoTipoAtividade());
          }
          this.$emit('tipoAtividadeAdicionado');
          this.$nextTick(() => document.getElementById('tipoprojtipoat-add-item').focus());
          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.showNotification({ text: `Ocorreu um erro ao adicionar o tipo atividade: ${error}.`, status: 'error' });
        }
      } else {
        this.tiposAtividadeAdicionar.push(newTipoProjetoTipoAtividade);
        this.tipoProjetoTipoAtividade = new TipoProjetoTipoAtividade();
        this.$nextTick(() => document.getElementById('tipoprojtipoat-add-item').focus());
      }
    },
    async adicionaTiposAtividadePendentes(idTipoProjeto) {
      if (this.tiposAtividadeAdicionar.length) {
        for (const tipoAtividade of this.tiposAtividadeAdicionar) {
          tipoAtividade.IdTipoProjeto = idTipoProjeto;
          await this.addTipoProjetoTipoAtividade(tipoAtividade);
        }
        this.tiposAtividadeAdicionar = [];
      } else {
        return;
      }
    },
    async excluiTipoAtividade(tipoAtividade) {
      if (tipoAtividade.IdTipoProjeto && confirm(`Desejar excluir o tipo atividade: ${tipoAtividade.TipoAtividade}?`)) {
        this.loading = true;
        try {
          await this.deleteTipoProjetoTipoAtividade(tipoAtividade);
          this.loading = false;
          // tipoAtividade = Object.assign({}, new TipoProjetoTipoAtividade());
          this.showNotification({ text: 'Tipo Atividade removido com sucesso.', status: 'success' });
        } catch (error) {
          this.loading = false;
          console.log(error);
          this.showNotification({ text: `Ocorreu um erro ao remover o tipo atividade: ${error}`, status: 'error' });
        }
      } else {
        this.showNotification({ text: `Operação cancelada.`, status: 'error' });
      }
    },
    async adiciona() {
      if (!this.tipoProjeto.IdTipoProjeto && this.tipoProjeto.Descricao) {
        this.loading = true;
        const newTipoProjeto = Object.assign({}, this.tipoProjeto);
        try {
          const id = await this.addTipoProjeto(newTipoProjeto);
          await this.adicionaTiposAtividadePendentes(id);
          this.showNotification({ text: `Tipo Projeto: ${newTipoProjeto.Descricao} adicionado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('tipoProjetoAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao adicionar o tipo Projeto: ${error}.`, status: 'error' });
        }
      } else if (this.tipoProjeto.IdTipoProjeto && this.tipoProjeto.Descricao) {
        this.loading = true;
        const updTipoProjeto = Object.assign({}, this.tipoProjeto);
        try {
          await this.updateTipoProjeto(updTipoProjeto);
          this.showNotification({ text: `Tipo Projeto: ${updTipoProjeto.Descricao} atualizado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('tipoProjetoAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao atualizar o tipo projeto: ${error}.`, status: 'error' });
        }
      } else {
        this.loading = false;
        this.showNotification({ text: `Informe a Descrição do tipo projeto.`, status: 'error' });
      }
    }
  },
}
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .title-mobile {
    font-size: 1.125rem !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
</style>
